module.exports = __webpack_public_path__ + "img/spinner.06bbd259.png";